import { c as _c } from "react/compiler-runtime";
import { POOL_CONFIG, type PoolId } from "@/constants/project-specific/nft-staking/pools";
import { type ChainId, fallbackChainId } from "../constants";
const imgWidth = "65px";
interface BarImageProps {
  url: any;
  pool: PoolId;
  chain?: ChainId;
}
export default function BarImage(t0) {
  const $ = _c(2);
  const {
    url,
    pool,
    chain
  } = t0;
  const chainId = chain ?? fallbackChainId;
  const imgFolder = POOL_CONFIG[chainId]?.[pool]?.imgFolder ?? String(pool);
  const t1 = `../images/pools/${Number(chainId)}/${String(imgFolder)}/${String(url)}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <img src={t1} width={imgWidth} height={imgWidth} className="mr-5 md:mr-0 text-left transition-all object-contain hover:scale-110 hover:-rotate-3 active:scale-100" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
export const barImgUrl = (url: string, pool: PoolId, chain?: ChainId) => {
  const chainId = chain ?? fallbackChainId;
  const imgFolder = POOL_CONFIG[chainId]?.[pool]?.imgFolder ?? String(pool);
  return `/images/pools/${Number(chainId)}/${String(imgFolder)}/${String(url)}`;
};